// Mirrors POST /projects/friendly-name (.../api/projects/friendly_name.py). A null
// or blank name clears it.
import { useMutation, useQueryClient } from "react-query";

import { useAgentsHttp } from "../useAgentsHttp";
import { QK, queryKeys } from "../queryKeys";

// Mirrors db.models.project.FRIENDLY_NAME_MAX_CHARS, so the form refuses before a
// round trip; the server refuses too.
export const FRIENDLY_NAME_MAX_CHARS = 120;

export interface SetProjectFriendlyNameResponse {
  project_id: string;
  friendly_name: string | null;
}

export const useSetProjectFriendlyName = (projectId: string) => {
  const http = useAgentsHttp();
  const qc = useQueryClient();
  return useMutation<
    SetProjectFriendlyNameResponse,
    Error,
    { friendly_name: string | null }
  >(
    (body) =>
      http<SetProjectFriendlyNameResponse>("/projects/friendly-name", {
        project_id: projectId,
        ...body,
      }),
    {
      onSuccess: () => {
        void qc.invalidateQueries(queryKeys.projectGet(projectId));
        void qc.invalidateQueries([QK.projectsList]);
        void qc.invalidateQueries([QK.dashboard]);
      },
    },
  );
};
